import { Box, Button, Grid, Paper, Typography } from '@mui/material';

export default function ResumenDia({ efectivo, qr, datos, inicioEfectivo = 0, inicioQR = 0, fechaFormato, díaBloqueado, onArqueo }) {
  const utilidadBruta = datos.ventas - datos.costos;

  const tarjeta = (label, valor, color, bg) => (
    <Grid item xs={12} sm={6} md={4}>
      <Box sx={{ p: 1.5, bgcolor: bg || '#fff', borderRadius: 1, border: '1px solid #e0e0e0' }}>
        <Typography variant="body2" color="textSecondary" sx={{ fontSize: '0.85rem' }}>
          {label}
        </Typography>
        <Typography variant="h6" sx={{ fontWeight: 'bold', color }}>
          {valor}
        </Typography>
      </Box>
    </Grid>
  );

  return (
    <Paper sx={{ p: 3, mb: 4, bgcolor: '#FAFAFA', borderLeft: '4px solid #1565C0' }}>
      <Typography variant="h6" sx={{ mb: 3, fontWeight: 'bold' }}>
        📊 Resumen del Día
      </Typography>

      <Grid container spacing={2} sx={{ mb: 3 }}>
        {tarjeta('📅 Fecha', fechaFormato, '#1565C0')}
        {tarjeta(
          '💰 Inicio Efectivo',
          `${inicioEfectivo.toFixed(2)}`,
          inicioEfectivo >= 0 ? '#2E7D32' : '#C62828'
        )}
        {tarjeta(
          '💰 Inicio QR',
          `${inicioQR.toFixed(2)}`,
          inicioQR >= 0 ? '#2E7D32' : '#C62828'
        )}
        {tarjeta(
          '💰 Saldo Efectivo',
          `${(inicioEfectivo + efectivo).toFixed(2)}`,
          inicioEfectivo + efectivo >= 0 ? '#2E7D32' : '#C62828'
        )}
        {tarjeta(
          '💰 Saldo QR',
          `${(inicioQR + qr).toFixed(2)}`,
          inicioQR + qr >= 0 ? '#2E7D32' : '#C62828'
        )}
        {tarjeta(
          '💵 Movimiento Efectivo',
          `${efectivo.toFixed(2)}`,
          efectivo >= 0 ? '#2E7D32' : '#C62828'
        )}
        {tarjeta(
          '📱 Movimiento QR',
          `${qr.toFixed(2)}`,
          qr >= 0 ? '#2E7D32' : '#C62828'
        )}
        {tarjeta('📦 Compras', `${datos.compras.toFixed(2)}`, '#1565C0')}
        {tarjeta('🛍️ Ventas', `${datos.ventas.toFixed(2)}`, '#2E7D32')}
        {tarjeta('💸 Gastos', `-${datos.gastos.toFixed(2)}`, '#D84315')}
        {tarjeta('💰 Costos', `-${datos.costos.toFixed(2)}`, '#D84315')}
        <Grid item xs={12} sm={6} md={4}>
          <Box sx={{
            p: 1.5, borderRadius: 1, border: '1px solid #BDBDBD',
            bgcolor: utilidadBruta >= 0 ? '#E8F5E9' : '#FFEBEE'
          }}>
            <Typography variant="body2" color="textSecondary" sx={{ fontSize: '0.85rem' }}>
              📈 Utilidad Bruta
            </Typography>
            <Typography variant="h6" sx={{ fontWeight: 'bold', color: utilidadBruta >= 0 ? '#2E7D32' : '#C62828' }}>
              {utilidadBruta.toFixed(2)}
            </Typography>
          </Box>
        </Grid>
        {tarjeta(
          '⚖️ Ajustes Efectivo',
          `${(datos.ajustesEfectivo || 0) >= 0 ? '+' : ''}${(datos.ajustesEfectivo || 0).toFixed(2)}`,
          (datos.ajustesEfectivo || 0) >= 0 ? '#2E7D32' : '#C62828'
        )}
        {tarjeta(
          '⚖️ Ajustes QR',
          `${(datos.ajustesQR || 0) >= 0 ? '+' : ''}${(datos.ajustesQR || 0).toFixed(2)}`,
          (datos.ajustesQR || 0) >= 0 ? '#2E7D32' : '#C62828'
        )}
      </Grid>

      <Button
        variant="contained"
        sx={{ bgcolor: '#37474F', color: '#fff', fontWeight: 'bold', width: '100%', padding: '12px' }}
        onClick={onArqueo}
        disabled={díaBloqueado}
      >
        🔍 Iniciar Arqueo de Caja
      </Button>
    </Paper>
  );
}
